import { render, staticRenderFns } from "./ServiceItem.vue?vue&type=template&id=6c1ac1cd&scoped=true"
import script from "./ServiceItem.vue?vue&type=script&lang=js"
export * from "./ServiceItem.vue?vue&type=script&lang=js"
import style0 from "./ServiceItem.vue?vue&type=style&index=0&id=6c1ac1cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1ac1cd",
  null
  
)

export default component.exports